import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

@Component({
  selector: 'rd-westpac-offer-listing-banner',
  templateUrl: './listing-banner.component.html',
  styleUrls: ['./listing-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WestpacOfferListingBannerComponent {
  @HostBinding('class') componentClasses =
    'rd-offer-listing-banner rd-westpac-offer-listing-banner';

  @Input() title = '';
}
